import { useEffect, useState } from 'react';
import ComposeForm from '../components/ComposeForm.jsx';
import { getStats } from '../api.js';

export default function Compose() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getStats()
      .then((s) => {
        if (!cancelled) setStats(s);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const total = stats?.allTime || 0;
  // Only show social proof once it's meaningful; small numbers read as "nobody is using this."
  const SOCIAL_PROOF_THRESHOLD = 250;
  const showCount = total >= SOCIAL_PROOF_THRESHOLD;

  return (
    <section className="mt-4 sm:mt-10">
      <div className="text-center mb-8">
        <h1 className="text-4xl sm:text-5xl font-display font-bold text-navy mb-3">
          Make someone&rsquo;s day.
        </h1>
        <p className="text-navy-700 text-lg max-w-xl mx-auto">
          Write a kind, honest compliment. We&rsquo;ll deliver it anonymously.
          They can pay it forward to someone else.
        </p>
        {showCount && (
          <p className="text-sm text-teal-700 mt-4 font-medium">
            💛 {total.toLocaleString()} kudos sent so far &mdash; yours next.
          </p>
        )}
      </div>
      <ComposeForm />
    </section>
  );
}
